export default __webpack_public_path__ + "static/media/coin.3bb83119.ogg";